import { createReducer, on } from '@ngrx/store';
import {
  addItemtoMyPurchase,
  addVendorsToMyPurchase,
  deleteVendorsFromMyPurchase,
  updateGeneralForm,
  updatePurchaseForm,
  clearStore,
  addAttachmenttoMyPurchase,
  deleteAttachmentsFromMyPurchase,
  updateAttachments,
  deleteBudgetFromMyPurchase,
  deleteItemFromMyPurchase,
  updateItemForm,
  updateBudgetForm,
  updateApprovingOfficer,
  updateApprovingOfficerRequired,
  updateWholeForm,
  updateMPNumber,
  deleteDraftItemFromMyPurchase,
  updateFormType,
  updateFormStatus,
  updateTenderItemForm,
  updateVendorsToMyPurchase,
  addOptionToPurchase,
  updateOptionToPurchase,
  updateTenderDate,
  deleteAddOnOptionFromMyPurchase,
  updateWOCToMyPurchase,
  updateDOTPToMyPurchase,
  updateIsRFSEnabled,
  updateRFQDeadline,
  updatePDPCompliance,
  updateItemsSourcingStatus,
  // addVendorTagging,
} from './form.actions';
import {
  IBudgetAllocForm,
  IItemToRequest,
  MyPurchaseForm,
} from 'src/app/shared/models/app-models/MyPurchaseForm.model';
import { DisplayItemNumberToSourcingStatusIdMap } from 'src/app/modules/mypurchase-form/rfs/tag-item-vendor.service';

export const initialState: MyPurchaseForm = {
  generalForm: {
    RO: { id: '', value: '' },
    internal: { id: '', value: '' },
    external: { id: '', value: '' },
    preApproved: { id: '', value: '' },
    areExcoBoardDocumentsAttached: { id: '2', value: 'No' },
    excoBoardDocumentArray: [],
    reasonForNotUsingRFQ: { id: '', value: '' },
    purpose: '',
    purchaseTitle: '',
    typeOfRequisition: { id: '', value: '' },
    requisitionOthers: null,
    permissibleReason: { id: '', value: '' },
    otherPermissibleReasons: '',
    blanketPurchaseType: { id: '', value: '' },
    blanketPurchaseDocumentArray: [],
    isDIRP: false
  },
  ItemList: [],
  VendorsToSource: [],
  WoCReason: null,
  DoTPReason: null,
  DOTPReasonId: null,
  isProjectRORequired: false,
  documentNo: '',
  parentDocumentNo: '',
  documentStatusId: 2, //initialize as new
  documentStatus: '',
  documentSubStatusId: 2,
  documentSubStatus: '',
  RFQDeadline: 7,
  createdBy: '',
  Type: '1',
  Env: 'OA',
  optionToPurchase: [],
  TenderStartDate: null,
  TenderEndDate: null,
  TenderStartTime: null,
  TenderEndTime: null,
  PurchaseTypeId: 1,
  TenderDocumentNumber: null,
  WOCFileReferenceNumber: null,
  WOCJustification: null,
  WOCId: null,
  DOTPJustification: null,
  DOTPRemarks: null,
  DOTPId: null,
  isRFSEnabled: false,
  PDPComplianceItemNumbers: null,
  ExchangeRateLock: false,
  rfqSummaryButton:false
};

export const formReducer = createReducer(
  initialState,

  on(updateGeneralForm, (state, { form }) => ({
    ...state,
    generalForm: form,
  })),

  on(addItemtoMyPurchase, (state, { form }) => ({
    ...state,
    ItemList: [...state.ItemList, form],
  })),

  on(updateBudgetForm, (state, { form }) => {
    try {
      let updatedItemList = state.ItemList.map((item: IItemToRequest) => {
        if (item.Strikethrough || item.isDeleted) return item
        let updatedBudgetAllocationArr = item.BudgetAllocation.map(
          (budgetFormAllocation: any) => {
            return form.iBudgetId == budgetFormAllocation.iBudgetId &&
              form.PurchaseItemNo == item.AddItems.itemId && form.isDeleted == budgetFormAllocation.isDeleted
              ? form
              : budgetFormAllocation;
          }
        );
        return {
          ...item,
          BudgetAllocation: updatedBudgetAllocationArr,
        };
      });
      return {
        ...state,
        ItemList: updatedItemList,
      };
    } catch (err) {
      return state;
    }
  }),
  on(updateItemForm, (state, { form }) => {
    try {
      // check if form is new, if new dont need send back deleted budgets
      if (state.documentStatusId == 2) {
        form = {
          ...form,
          BudgetAllocation: form.BudgetAllocation.filter(
            (budget) => !budget.isDeleted
          ),
        };
      }

      let updatedForm = state.ItemList.map((item: any, index: number) => {
        return form.AddItems.itemId === item.AddItems.itemId
          ? form
          : state.ItemList[index];
      });
      console.log('updated item form original', form)
      console.log('updated item form', updatedForm)
      return {
        ...state,
        ItemList: updatedForm,
      };
    } catch (err) {
      return state;
    }
  }),
  on(updateItemsSourcingStatus, (state, { displayItemNumberToSourcingStatusIdMap, purchaseExecutive }) => {
    const map: DisplayItemNumberToSourcingStatusIdMap =
      displayItemNumberToSourcingStatusIdMap;

    const updatedItemList: MyPurchaseForm['ItemList'] = state.ItemList.map(
      (item): IItemToRequest => {
        // Only allowed to change sourcing status of items assigned to current purchase executive
        if (!item.AddItems.PurchaseExecutive || item.AddItems.PurchaseExecutive?.toLowerCase() !== purchaseExecutive.toLowerCase()) {
          return item;
        }

        const { isDeleted, Strikethrough } = item;
        const { displayItemNumber } = item.AddItems;

        const taggedSourcingStatusId = map.get(displayItemNumber);

        if (taggedSourcingStatusId && !isDeleted && !Strikethrough) {
          // This item has been tagged in taggedGroups
          return {
            ...item,
            AddItems: {
              ...item.AddItems,
              // Change SourcingStatusId to reflect selected sourcing status in taggedGroup
              SourcingStatusId: taggedSourcingStatusId,
            },
          };
        }

        return {
          ...item,
          AddItems: {
            ...item.AddItems,
            SourcingStatusId: null,
          },
        };
      }
    );

    return {
      ...state,
      ItemList: updatedItemList,
    };
  }),
  on(addVendorsToMyPurchase, (state, { vendors }) => ({
    ...state,
    VendorsToSource: [...vendors, ...state.VendorsToSource],
  })),
  on(updateVendorsToMyPurchase, (state, { vendors }) => ({
    ...state,
    VendorsToSource: [...vendors],
  })),
  on(deleteItemFromMyPurchase, (state, { itemId }) => {
    const itemList = state.ItemList.map((item) => ({ ...item }));
    let indextoDelete = itemList.findIndex(
      (item) => item.AddItems.itemId == itemId
    );

    // Matches any item, if Document sub status = New or Draft
    let isDraftStatus = state.documentSubStatusId === 1 || state.documentSubStatusId === 2;

    let budgetAllocations: IBudgetAllocForm[] = itemList[
      indextoDelete
    ].BudgetAllocation.map((budget) => {
      return {
        ...budget,
        isDeleted: true,
      };
    });
    itemList[indextoDelete] = {
      ...itemList[indextoDelete],
      isDeleted: true,
      BudgetAllocation: budgetAllocations,
    };

    if (isDraftStatus || !itemList[indextoDelete].AddItems.PurchaseItemId) {
      itemList[indextoDelete].AddItems = {
        ...itemList[indextoDelete].AddItems,
        displayItemNumber: 0
      }
    }

    // Reset all displayItemNumber if is new/draft document
    if (isDraftStatus) {
      let itemNumber = 1;
      for(const item of itemList) {
        // Ignore isDeleted item, skip assigning item number to it
        if (item.isDeleted) {
          continue;
        }

        item.AddItems = {
          ...item.AddItems,
          displayItemNumber: itemNumber
        }
        itemNumber++;
      }
    } else if (itemList.some(item => !item.AddItems.PurchaseItemId)) {
      // Not new/draft, but other workflow draft status (e.g. AOR draft) with new added items
      // New added items will always be at the back of the array
      let nextItemNumber = 1;
      for(const item of itemList) {
        const {displayItemNumber, PurchaseItemId} = item.AddItems

        if (PurchaseItemId) {
          nextItemNumber = Math.max(nextItemNumber, displayItemNumber + 1)
          // Skip reassigning displayItemNumber for item that is already saved to database
          // Lock the displayItemNumber
          continue;
        } 
        if (item.isDeleted) {
          // Skip assigning displayItemNumber for deleted items not saved to database
          continue;
        }
        item.AddItems = {
          ...item.AddItems,
          displayItemNumber: nextItemNumber
        }
        nextItemNumber++;
      }
    }

    return {
      ...state,
      ItemList: itemList,
    };
  }),
  on(deleteDraftItemFromMyPurchase, (state, { itemId }) => {
    try {
      let itemList = state.ItemList.slice();
      let indextoDelete = state.ItemList.findIndex(
        (item) => item.AddItems.itemId == itemId
      );
      itemList.splice(indextoDelete, 1);
      itemList = itemList.map((item, index) => {
        let budgetAllocations = item.BudgetAllocation.slice()
        budgetAllocations = budgetAllocations.map(x=>({
          ...x,
          PurchaseItemNo: index + 1,
          displayPurchaseItemNumber: index + 1,
        }))
        return {
          ...item,
          AddItems: {
            ...item.AddItems,
            itemId: index + 1,      
            displayItemNumber: index + 1,      
          },
          BudgetAllocation: budgetAllocations
        };
      });
      return {
        ...state,
        ItemList: itemList,
      };
    } catch (err) {
      console.log('the err for deleting items : ', err);
      return state;
    }
  }),
  on(deleteVendorsFromMyPurchase, (state, { vendors }) => {
    return {
      ...state,
      VendorsToSource: vendors,
    };
  }),
  on(deleteBudgetFromMyPurchase, (state, { form }) => {
    const budgetList = state.ItemList.filter((item: any) => {
      if (item.AddItems.itemId && item.AddItems.itemId == form.PurchaseItemNo) {
        item.BudgetAllocation.filter((budget: any) => {
          return budget.iBudgetId !== form.iBudgetId;
        });
      }
    });
    return {
      ...state,
      BudgetAllocation: budgetList,
    };
  }),
  on(
    updateApprovingOfficer,
    (state, { approvingOfficer, itemNo, budgetInfo }) => {
      // const itemNoList: string[] = itemNo.split(',');
      let NewBudgetList = state.ItemList.map((item: any, index: number) => {
        // if (itemNoList.includes((index + 1).toString())) {
          let budgetList = item.BudgetAllocation.map(
            (budget: IBudgetAllocForm) => {
              if (budget.ProjectCode?.id == budgetInfo.id) {
                return { ...budget, ApprovingOfficer: approvingOfficer };
              }
              return budget;
            }
          );
          return { ...item, BudgetAllocation: budgetList };
        // }
        // return item;
      });
      console.log(NewBudgetList);
      return {
        ...state,
        ItemList: [...NewBudgetList],
      };
    }
  ),
  on(updateApprovingOfficerRequired, (state, { isRequired }) => {
    return {
      ...state,
      isProjectRORequired: isRequired,
    };
  }),
  on(clearStore, (state) => {
    return {
      ...initialState,
    };
  }),
  on(updateWholeForm, (state, { form }) => {
    return { ...form };
  }),
  on(updateMPNumber, (state, { MPNumber }) => {
    return {
      ...state,
      documentNo: MPNumber,
    };
  }),
  on(updateFormType, (state, { typeId }) => {
    return {
      ...state,
      PurchaseTypeId: typeId,
    };
  }),
  on(updateIsRFSEnabled, (state, { isRFSEnabled }) => {
    return {
      ...state,
      isRFSEnabled: isRFSEnabled,
    };
  }),
  on(updateFormStatus, (state, { formStatus }) => {
    return {
      ...state,
      documentStatusId: formStatus.documentStatusId,
      documentSubStatusId: formStatus.documentSubStatusId,
      createdBy: formStatus.createdBy,
      CreatedOn: formStatus.CreatedOn,
    };
  }),
  on(updateTenderItemForm, (state, { form }) => ({
    ...state,
    TenderItem: form,
  })),
  on(addOptionToPurchase, (state, { option }) => ({
    ...state,
    optionToPurchase: [
      ...(state.optionToPurchase || []),
      { ...option, actualIdx: (state.optionToPurchase?.length || 0)},
    ],
  })),
  on(updateOptionToPurchase, (state, { option }) => {

    // const newOptionToPurchase = state.optionToPurchase?.map((item, index) => {
    //   if (
    //     (item.ItemAddOnId &&
    //       option.ItemAddOnId &&
    //       item.ItemAddOnId === option.ItemAddOnId) ||
    //     index === actualIdx
    //   ) {
    //     return option;
    //   } else {
    //     return item;
    //   }
    // });
    const index = option.ItemAddOnId
      ? state.optionToPurchase?.findIndex(
          (item) => item.ItemAddOnId === option.ItemAddOnId
        )
      : option.actualIdx;
    const newOTPState = [
      ...state.optionToPurchase!.slice(0, index as number),
      option,
      ...state.optionToPurchase!.slice(index as number + 1),
    ];

    return {
      ...state,
      optionToPurchase: [...(newOTPState || [])],
    };
  }),
  on(
    deleteAddOnOptionFromMyPurchase,
    (state, { itemId, actualIdx }) => {
      const index = itemId
      ? state.optionToPurchase?.findIndex(
          (item) => item.ItemAddOnId === itemId
        )
      : actualIdx;
      const newOTPState = [
        ...state.optionToPurchase!.slice(0, index as number),
        { ...state.optionToPurchase![index as number], isDeleted: true },
        ...state.optionToPurchase!.slice(index as number + 1),
      ];

      return { ...state, optionToPurchase: newOTPState };
    }
  ),
  on(updateTenderDate, (state, { TenderDate }) => ({
    ...state,
    TenderEndDate: TenderDate.EndDate,
    TenderStartDate: TenderDate.StartDate,
    TenderEndTime: TenderDate.EndTime,
    TenderStartTime: TenderDate.StartTime,
  })),

  on(updateWOCToMyPurchase, (state, { woc }) => ({
    ...state,
    WoCReason: woc.reason,
    WOCFileReferenceNumber: woc.fileReferenceNumber,
    WOCJustification: woc.justification,
    WOCId: woc.wocId,
  })),

  on(updateDOTPToMyPurchase, (state, { dotp }) => ({
    ...state,
    DoTPReason: dotp.reason,
    DOTPJustification: dotp.justification,
    DOTPRemarks: dotp.remarks,
    DOTPId: dotp.dotpId,
  })),
  on(updateRFQDeadline, (state, { RFQDeadline }) => {
    return {
      ...state,
      RFQDeadline: RFQDeadline,
    };
  }),
  on(updatePDPCompliance, (state, { PDPComplianceItemNumbers }) => {
    return {
      ...state,
      PDPComplianceItemNumbers: PDPComplianceItemNumbers,
    };
  })

  // on(addVendorTagging, (state, { VendorTagging }) => ({
  //   ...state,
  //   id: VendorTagging.id,
  //   vendorNumber: VendorTagging.vendorNumber,
  //   status: VendorTagging.status
  // })),
);
